import { BehaviorSubject } from 'rxjs';

const MENU_CLOSED = 0;
const MENU_OPEN = 1;
const MENU_USLUGI = 2;
const MENU_COMPANY = 3;
const MENU_PHOTOS = 4;

const subject = new BehaviorSubject(MENU_CLOSED);

const burger = document.querySelector('.navbar__burger');
const burgerClose = document.querySelector('.navbar__burger--close');
const burgerBack = document.querySelector('.navbar__burger--back');
const menu = document.querySelector('.menu');
const overlay = document.querySelector('.menu__overlay');

const listMain = document.querySelector('.menu__list');
const listUslugi = document.querySelector('.menu__list--uslugi');
const listCompany = document.querySelector('.menu__list--company');
const listCatalog = document.querySelector('.menu__list--catalog');

const showMenu = () => {
    if (menu.classList.contains('hidden')) {
        menu.classList.remove('hidden');
    }
    overlay && overlay.classList.remove('hidden');
    burger.classList.add('hidden');
    burgerBack.classList.add('hidden');
    burgerClose.classList.remove('hidden');
    listMain.classList.remove('hidden');
    if (!listUslugi.classList.contains('hidden')) {
        listUslugi.classList.add('hidden');
    }
    if (!listCompany.classList.contains('hidden')) {
        listCompany.classList.add('hidden');
    }
    if (!listCatalog.classList.contains('hidden')) {
        listCatalog.classList.add('hidden');
    }
};
const closeMenu = () => {
    if(!burger || !menu) {
        return;
    }
    
    burger.classList.remove('hidden');
    if (!menu.classList.contains('hidden')) {
        menu.classList.add('hidden');
    }
    overlay && overlay.classList.add('hidden');
    if (!burgerClose.classList.contains('hidden')) {
        burgerClose.classList.add('hidden');
    }
    if (!burgerBack.classList.contains('hidden')) {
        burgerBack.classList.add('hidden');
    }
};
const showUslugi = () => {
    if (!burger.classList.contains('hidden')) {
        burger.classList.add('hidden');
    }
    if (!burgerClose.classList.contains('hidden')) {
        burgerClose.classList.add('hidden');
    }
    burgerBack.classList.remove('hidden');
    listMain.classList.add('hidden');
    listUslugi.classList.remove('hidden');
};
const showCompany = () => {
    if (!burger.classList.contains('hidden')) {
        burger.classList.add('hidden');
    }
    if (!burgerClose.classList.contains('hidden')) {
        burgerClose.classList.add('hidden');
    }
    burgerBack.classList.remove('hidden');
    listMain.classList.add('hidden');
    listCompany.classList.remove('hidden');
};
const showPhotos = () => {
    if (!burger.classList.contains('hidden')) {
        burger.classList.add('hidden');
    }
    if (!burgerClose.classList.contains('hidden')) {
        burgerClose.classList.add('hidden');
    }
    burgerBack.classList.remove('hidden');
    listMain.classList.add('hidden');
    listCatalog.classList.remove('hidden');
};

function onValueChange(newValue) {
    switch (newValue) {
        case MENU_OPEN:
            showMenu();
            break;
        case MENU_CLOSED:
            closeMenu();
            break;
        case MENU_USLUGI:
            showUslugi();
            break;
        case MENU_COMPANY:
            showCompany();
            break;
        case MENU_PHOTOS:
            showPhotos();
            break;
    }
}

subject.subscribe(onValueChange);

const mainMenuBtns = document.querySelectorAll('.menu__item--main');
[...mainMenuBtns].map(mainMenuBtn => {
    mainMenuBtn.addEventListener('click', () => {
        const stateVal = Number(mainMenuBtn.getAttribute('data-state'));
        subject.next(stateVal);
    })
});

burger && burger.addEventListener('click', () => {
    subject.next(MENU_OPEN);
});
burgerClose && burgerClose.addEventListener('click', () => {
    subject.next(MENU_CLOSED);
});
burgerBack && burgerBack.addEventListener('click', () => {
    subject.next(MENU_OPEN)
});
overlay && overlay.addEventListener('click', () => {
    subject.next(MENU_CLOSED);
});
